const SITE_URL = "https://ebikesandgear.co.uk";

const DEFAULT_KEYWORDS =
  "electric bikes Kent, e-bike shop Canterbury CT1 2SY, Premium Carbon E-Bikes EU, 2026 Specialized S-Works Stockist, Trek SLR 9 Price Europe, Professional Road Bike Maintenance Parts, Fastest XC Bikes 2026, buy Specialized Trek Europe";

const DEFAULT_IMAGE = `${SITE_URL}/images/site/hero.jpg`;

export default function SEO({
  title,
  description,
  path = "",
  image,
  type = "website",
  keywords = DEFAULT_KEYWORDS,
  jsonLd,
}) {
  const fullTitle = title ? `${title} | Ebikes&Gear` : "Premium Electric Bikes Kent | Ebikes&Gear — 2026 Specialized & Trek Stockist";
  const url = `${SITE_URL}${path}`;
  const ogImage = image ? (image.startsWith("http") ? image : `${SITE_URL}${image}`) : DEFAULT_IMAGE;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd).replace(/</g, "\\u003c") }} />
      )}
    </>
  );
}
